export interface DataEntity_Detail_09_Interface {
    id: number,
    main_id: number,
  
    reference_Value: string,
    mesured:Array<string>,

    uncertainty: string,
    converage: string,
    mesured_visible:boolean

  }
  
  export function Empty_DataEntity_Detail_09_Interface(): DataEntity_Detail_09_Interface {
    return {
      id: 0,
      main_id: 0,
  
      reference_Value: '',
      mesured:[] ,

      uncertainty: '',
      converage: '',

      mesured_visible:false
    }
  }
